import { Box, Flex, Text } from '@mantine/core';
import { WARNING_COLOR } from '../../waiting-phase/NachversandBanner';
import { NACHVERSAND_GREEN } from '../utils';

export const NachversandCard = ({
  title,
  warning = false,
  children,
}: {
  title: string;
  warning?: boolean;
  children: React.ReactNode;
}) => {
  const accentColor = warning ? WARNING_COLOR : NACHVERSAND_GREEN;

  return (
    <Box
      w="100%"
      py={16}
      px={16}
      style={{ border: `2px solid ${accentColor}`, borderRadius: 8 }}
    >
      <Text
        mb="12px"
        fw={700}
        size="16px"
        c={warning ? WARNING_COLOR : '#202020'}
      >
        {title}
      </Text>
      <Flex direction="column" gap="16px">
        {children}
      </Flex>
    </Box>
  );
};
